// Types
import { ResponseGpoSearch } from "interfaces/searchPage/osaSearch";

export const NUMBER_ELEMENTS_SUGGESTION = 15;
export const NUMBER_ELEMENTS_PER_PAGE = 15;

export const defaultResultsQuery: ResponseGpoSearch = {
	totalRows: 0,
	currentRows: 0,
	results: []
};

export const startDateOption: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
export const endDateOption: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
